import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyClipboardDirective } from './copy-clipboard.directive';
import {DragDropDirective} from './drag-drop.directive';

@NgModule({
  imports: [CommonModule],
  exports: [
    CopyClipboardDirective,
    DragDropDirective
  ],
  declarations: [
    CopyClipboardDirective,
    DragDropDirective
  ],
  providers: [],
})
export class DirectivesModule { }